import { setTerm } from './helpers';

export const setPenthouse = setTerm('penthouse');
